import { FC, ReactNode } from "react";
import { experimentalStyled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./Header";
import { Navigate } from "react-router";
import { useAuth } from "../../auth/AuthProvider";
import { WsProvider } from "../../store/WsProvider";


interface SidebarLayoutProps {
  children?: ReactNode;
}

const MainWrapper = experimentalStyled(Box)(
  ({ theme }) => `
        flex: 1 1 auto;
        display: flex;
        height: 100%;
        
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            padding-left: ${theme.sidebar.width};
        }
`
);

const MainContent = experimentalStyled(Box)(
  ({ theme }) => `
        margin-top: ${theme.header.height};
        flex: 1 1 auto;
        overflow: auto;
`
);

const Protected = (props) => {
  return (<>
    {props.isLoggedIn ? props.children : <Navigate to="/login" />}
  </>);
}

const SidebarLayout: FC<SidebarLayoutProps> = () => {

  const profile = useAuth().getProfile();

  return (
    <Protected isLoggedIn={profile && !profile.groups.includes('Client')}>
      <WsProvider />
      { process.env.REACT_APP_IS_DEV === 'true' &&
          <div style={{width: "100%", color: "white", backgroundColor: "red", position: "relative", fontSize: "1.5em", fontWeight: "900", padding: "1em"}}>
            Ceci est la version en DÉVELOPPEMENT 20230308 de la plateforme.<br/>
            SVP utilisez <a href="https://anacolor.groupebaillargeon.com">https://anacolor.groupebaillargeon.com</a>
          </div>
      }
      <Sidebar />
      <MainWrapper>
        <Header />
        <MainContent>
          <Outlet />
        </MainContent>
      </MainWrapper>
    </Protected>
  );
};

export default SidebarLayout;
